import {css} from 'lit'; export default css`.audience-export-snapshot__tooltip{--fly-tooltip-anchor-display:block}`;
    